module.exports = __webpack_public_path__ + "media/images/img-warrior-c204c9437e4c77332d42e8da597a110e.png";